
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'pricing-pages-ui',
  currentProjectVersion: 'static-1.38999',
  depVersions: {
  "pricing-pages-ui": "static-1.38999",
  "apollo-dlb": "static-3.41",
  "client-types": "static-1.373",
  "data-fetching-client": "static-1.8424",
  "demographics-service-types": "static-1.649",
  "eligibility-engine-service-types": "static-1.2181",
  "feature-store-service-types": "static-1.3492",
  "foundations-assets": "static-1.3735",
  "graphql": "static-1.58",
  "growth-monetization-service-types": "static-1.3499",
  "head-dlb": "static-1.4003",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6807",
  "hub-http": "static-1.4807",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10307",
  "I18n": "static-7.1391",
  "jasmine": "static-4.3149",
  "jasmine-runner": "static-1.5214",
  "laboratory-lib": "static-3.6064",
  "personalization-service-types": "static-1.2002",
  "pricing-pages-api": "static-1.7892",
  "pricing-pages-lib": "static-1.28709",
  "purchase-motions-components": "static-1.3970",
  "quartz": "static-1.5561",
  "react-dlb": "static-1.53",
  "react-rhumb": "static-1.15388",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.3523",
  "sanitize-text": "static-1.6985",
  "self-service-api": "static-1.9014",
  "signup-constants": "static-1.16280",
  "styled-components": "static-2.64",
  "trials-service-types": "static-1.2900",
  "ui-addon-upgrades": "static-9.16046",
  "upgrade-management-service-types": "static-1.3483",
  "usage-tracker-container": "static-1.6266",
  "webpack-env": "static-1.54",
  "account-and-billing-fintech-outages": "static-3.15272",
  "copilot-toolkit": "static-1.6395",
  "demographics-client": "static-1.4218",
  "enviro": "static-4.306",
  "foundations-components": "static-1.6006",
  "foundations-theming": "static-1.3128",
  "growth-payments-core": "static-1.21168",
  "hubspot-url-utils": "static-1.3063",
  "js-cookie": "static-1.18",
  "metrics-js": "static-1.8459",
  "onboarding-scopes": "static-1.5365",
  "payments-enrollment-embed-lib": "static-1.17742",
  "PortalIdParser": "static-2.284",
  "prefetcher": "static-1.4588",
  "pricing-pages-ui-components": "static-1.8030",
  "quartz-core": "static-1.4780",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4766",
  "react": "static-7.151",
  "react-redux": "static-7.16",
  "react-utils": "static-2.4326",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "SharedI18nStrings": "static-1.162",
  "signup-ui-url-generator": "static-2.6867",
  "touchless-buying-components": "static-1.3346",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10920",
  "ui-addon-i18n": "static-1.9734",
  "ui-addon-iframeable": "static-1.7702",
  "ui-addon-react-router-dom": "static-1.8417",
  "ui-addon-video-player": "static-1.7576",
  "UIComponents": "static-3.7255",
  "usage-tracker-core": "static-1.6126",
  "usage-tracker-multi": "static-1.4690",
  "apollo-stack-hubspot": "static-3.43",
  "hs-promise-rejection-tracking": "static-1.4306",
  "raven-hubspot": "static-1.5073",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "bend-plugin-trellis-migration": "static-1.2455",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1838",
  "quartz-webpack": "static-1.1785",
  "msw": "static-1.39",
  "ts-schema": "static-1.3137",
  "hs-story-utils": "static-1.8202",
  "HeadJS": "static-2.577",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1918",
  "testing-library": "static-1.120",
  "i18n-data": "static-1.197",
  "moment-timezone": "static-5.51",
  "superstore": "static-1.3580",
  "marketing-contacts-client": "static-1.6446",
  "nav-client-types": "static-1.1156",
  "purchase-motions-api": "static-1.3972",
  "usage-tracker": "static-1.6276",
  "quartz-core-utils": "static-1.2428",
  "StyleGuideUI": "static-3.461",
  "autolinker": "static-3.11",
  "sanitize": "static-1.3194",
  "csstype": "static-1.38",
  "atom": "static-1.4017",
  "cssUtils": "static-1.495",
  "HubStyle": "static-2.10616",
  "icons": "static-2.592",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.500",
  "chatspot-client-types": "static-1.8590",
  "chatspot-core": "static-1.15633",
  "bend-plugin-foundations-components": "static-1.2274",
  "floating-ui": "static-1.28",
  "foundations-theming-specialty": "static-1.845",
  "react-aria": "static-1.38",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.73",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.332",
  "ui-images": "static-2.835",
  "bend-plugin-foundations-theming": "static-1.1611",
  "foundations-theming-base": "static-1.2113",
  "commerce-analytics-service-client": "static-1.2515",
  "frontend-preferences-client": "static-1.6679",
  "hs-lodash": "static-4.45",
  "ui-addon-opt": "static-4.7446",
  "crm_data": "static-4.86780",
  "customer-data-objects-ui-components": "static-1.11696",
  "growth-onboarding-confetti": "static-1.1915",
  "growth-onboarding-feedback-components": "static-1.5259",
  "growth-onboarding-reliability": "static-1.3965",
  "marketplace-ui-apps-core": "static-1.12854",
  "onboarding-tours": "static-1.14299",
  "stripe-embedded-components": "static-1.5253",
  "storybook-react": "static-1.3",
  "dispatcher": "static-1.112",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.648",
  "hub-http-shared-msw-handlers": "static-1.7072",
  "hubspotter-http": "static-1.3587",
  "hubspotter-http-shared-msw-handlers": "static-1.7070",
  "mobile-manifest-mixins": "static-1.348",
  "platform-navigation-bootstrap": "static-1.11219",
  "immer": "static-1.33",
  "checkout-sdk": "static-3.21098",
  "checkout-service-types": "static-1.2930",
  "company-details-components": "static-1.4729",
  "emoji-regex": "static-1.7",
  "foundations-components-test-utils": "static-1.3491",
  "payment-method-components": "static-1.5376",
  "upgrade-catalog-service-types": "static-1.2621",
  "ai-components-ui-library": "static-1.5243",
  "hs-promise-utils": "static-1.4338",
  "hubs-service-types": "static-1.271",
  "user-context": "static-1.3984",
  "magpie-lib": "static-1.4481",
  "navigation-messaging": "static-1.3194",
  "usage-tracker-anonymous": "static-1.4693",
  "usage-tracker-public": "static-1.6087",
  "sassPrefix": "static-1.131",
  "feedback-loader": "static-1.26566",
  "crm_schema": "static-3.86817",
  "crm_universal": "static-1.20560",
  "customer-data-email": "static-1.15794",
  "customer-data-objects": "static-1.6422",
  "customer-data-ui-utilities": "static-1.8533",
  "native-integrations-shared-strings": "static-1.6647",
  "property-translator": "static-1.4199",
  "avatar-components": "static-1.1240",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.6956",
  "ui-addon-avatars": "static-2.8156",
  "developer-experience-shared-components": "static-1.8978",
  "immutable-less": "static-1.3365",
  "marketplace-ui-client-types": "static-1.11724",
  "marketplace-ui-common": "static-1.14318",
  "ui-addon-integrations-directory-panel": "static-2.6805",
  "ui-extensibility-client-types": "static-1.2966",
  "ui-universal-auth": "static-1.7608",
  "getting-started-shared-tasks": "static-1.12634",
  "growth-data-modal": "static-1.4034",
  "navigation-components": "static-1.13867",
  "ui-shepherd-react": "static-3.8871",
  "ui-shepherd-tracker": "static-1.6252",
  "stripe-connect-js": "static-1.40",
  "platform-infra-nav-components": "static-1.6694",
  "hub-http-rxjs": "static-1.616",
  "normalizr": "static-3.9",
  "PatternValidationJS": "static-1.437",
  "ramda": "static-1.7",
  "rxjs": "static-5.10",
  "company-details-service-types": "static-1.2731",
  "final-form": "static-1.39",
  "billing-payments-client-types": "static-1.2802",
  "ContentUtils": "static-1.63292",
  "getting-started-shared-tasks-store": "static-1.11752",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3941",
  "simple-logging-lib": "static-1.1845",
  "FormUrlGenerator": "static-2.3532",
  "apollo-link-hub-http": "static-2.3589",
  "FileManagerCore": "static-1.34141",
  "FileManagerLib": "static-1.34282",
  "hubspot-apollo-client": "static-1.3634",
  "react-immutable-render-mixin": "static-1.9",
  "timezone-utils": "static-2.4054",
  "ui-gdpr-components": "static-1.9053",
  "react-dnd-compat": "static-1.3465",
  "apps-service-types": "static-1.2899",
  "oauth-service-types": "static-1.3110",
  "ai-settings-ui-library": "static-1.5926",
  "nav-meta": "static-1.25504",
  "react-window": "static-1.13",
  "cms-field-types": "static-1.3596",
  "content-icons-ui": "static-1.1892",
  "underscore": "static-1.8",
  "audio-components": "static-1.4466",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.18641",
  "FileManagerImages": "static-1.31792",
  "urlinator": "static-1.3357",
  "video-components": "static-1.7915",
  "video-data-lib": "static-1.29563",
  "video-embed": "static-1.30404",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "content-assistance-lib": "static-1.6313",
  "media-bridge-lib": "static-1.16720",
  "immerable": "static-1.2957",
  "social-insights-client-types": "static-1.17800",
  "outpost": "static-1.3167",
  "react-transition-group": "static-1.7",
  "ui-coaching-tips": "static-1.22956"
},
  depPathPrefixes: {
  "pricing-pages-ui": "/pricing-pages-ui/static-1.38999",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "client-types": "/client-types/static-1.373",
  "data-fetching-client": "/data-fetching-client/static-1.8424",
  "demographics-service-types": "/demographics-service-types/static-1.649",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2181",
  "feature-store-service-types": "/feature-store-service-types/static-1.3492",
  "foundations-assets": "/foundations-assets/static-1.3735",
  "graphql": "/graphql/static-1.58",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3499",
  "head-dlb": "/head-dlb/static-1.4003",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6807",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10307",
  "I18n": "/I18n/static-7.1391",
  "jasmine": "/jasmine/static-4.3149",
  "jasmine-runner": "/jasmine-runner/static-1.5214",
  "laboratory-lib": "/laboratory-lib/static-3.6064",
  "personalization-service-types": "/personalization-service-types/static-1.2002",
  "pricing-pages-api": "/pricing-pages-api/static-1.7892",
  "pricing-pages-lib": "/pricing-pages-lib/static-1.28709",
  "purchase-motions-components": "/purchase-motions-components/static-1.3970",
  "quartz": "/quartz/static-1.5561",
  "react-dlb": "/react-dlb/static-1.53",
  "react-rhumb": "/react-rhumb/static-1.15388",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.3523",
  "sanitize-text": "/sanitize-text/static-1.6985",
  "self-service-api": "/self-service-api/static-1.9014",
  "signup-constants": "/signup-constants/static-1.16280",
  "styled-components": "/styled-components/static-2.64",
  "trials-service-types": "/trials-service-types/static-1.2900",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16046",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3483",
  "usage-tracker-container": "/usage-tracker-container/static-1.6266",
  "webpack-env": "/webpack-env/static-1.54",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15272",
  "copilot-toolkit": "/copilot-toolkit/static-1.6395",
  "demographics-client": "/demographics-client/static-1.4218",
  "enviro": "/enviro/static-4.306",
  "foundations-components": "/foundations-components/static-1.6006",
  "foundations-theming": "/foundations-theming/static-1.3128",
  "growth-payments-core": "/growth-payments-core/static-1.21168",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "js-cookie": "/js-cookie/static-1.18",
  "metrics-js": "/metrics-js/static-1.8459",
  "onboarding-scopes": "/onboarding-scopes/static-1.5365",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17742",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "prefetcher": "/prefetcher/static-1.4588",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.8030",
  "quartz-core": "/quartz-core/static-1.4780",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4766",
  "react": "/react/static-7.151",
  "react-redux": "/react-redux/static-7.16",
  "react-utils": "/react-utils/static-2.4326",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6867",
  "touchless-buying-components": "/touchless-buying-components/static-1.3346",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10920",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9734",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7702",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8417",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7576",
  "UIComponents": "/UIComponents/static-3.7255",
  "usage-tracker-core": "/usage-tracker-core/static-1.6126",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4690",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
  "raven-hubspot": "/raven-hubspot/static-1.5073",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2455",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1838",
  "quartz-webpack": "/quartz-webpack/static-1.1785",
  "msw": "/msw/static-1.39",
  "ts-schema": "/ts-schema/static-1.3137",
  "hs-story-utils": "/hs-story-utils/static-1.8202",
  "HeadJS": "/HeadJS/static-2.577",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1918",
  "testing-library": "/testing-library/static-1.120",
  "i18n-data": "/i18n-data/static-1.197",
  "moment-timezone": "/moment-timezone/static-5.51",
  "superstore": "/superstore/static-1.3580",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6446",
  "nav-client-types": "/nav-client-types/static-1.1156",
  "purchase-motions-api": "/purchase-motions-api/static-1.3972",
  "usage-tracker": "/usage-tracker/static-1.6276",
  "quartz-core-utils": "/quartz-core-utils/static-1.2428",
  "StyleGuideUI": "/StyleGuideUI/static-3.461",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.3194",
  "csstype": "/csstype/static-1.38",
  "atom": "/atom/static-1.4017",
  "cssUtils": "/cssUtils/static-1.495",
  "HubStyle": "/HubStyle/static-2.10616",
  "icons": "/icons/static-2.592",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.500",
  "chatspot-client-types": "/chatspot-client-types/static-1.8590",
  "chatspot-core": "/chatspot-core/static-1.15633",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2274",
  "floating-ui": "/floating-ui/static-1.28",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.845",
  "react-aria": "/react-aria/static-1.38",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.73",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.332",
  "ui-images": "/ui-images/static-2.835",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1611",
  "foundations-theming-base": "/foundations-theming-base/static-1.2113",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2515",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6679",
  "hs-lodash": "/hs-lodash/static-4.45",
  "ui-addon-opt": "/ui-addon-opt/static-4.7446",
  "crm_data": "/crm_data/static-4.86780",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11696",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1915",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5259",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3965",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12854",
  "onboarding-tours": "/onboarding-tours/static-1.14299",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5253",
  "storybook-react": "/storybook-react/static-1.3",
  "dispatcher": "/dispatcher/static-1.112",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.648",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7072",
  "hubspotter-http": "/hubspotter-http/static-1.3587",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7070",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11219",
  "immer": "/immer/static-1.33",
  "checkout-sdk": "/checkout-sdk/static-3.21098",
  "checkout-service-types": "/checkout-service-types/static-1.2930",
  "company-details-components": "/company-details-components/static-1.4729",
  "emoji-regex": "/emoji-regex/static-1.7",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3491",
  "payment-method-components": "/payment-method-components/static-1.5376",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2621",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5243",
  "hs-promise-utils": "/hs-promise-utils/static-1.4338",
  "hubs-service-types": "/hubs-service-types/static-1.271",
  "user-context": "/user-context/static-1.3984",
  "magpie-lib": "/magpie-lib/static-1.4481",
  "navigation-messaging": "/navigation-messaging/static-1.3194",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4693",
  "usage-tracker-public": "/usage-tracker-public/static-1.6087",
  "sassPrefix": "/sassPrefix/static-1.131",
  "feedback-loader": "/feedback-loader/static-1.26566",
  "crm_schema": "/crm_schema/static-3.86817",
  "crm_universal": "/crm_universal/static-1.20560",
  "customer-data-email": "/customer-data-email/static-1.15794",
  "customer-data-objects": "/customer-data-objects/static-1.6422",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8533",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6647",
  "property-translator": "/property-translator/static-1.4199",
  "avatar-components": "/avatar-components/static-1.1240",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.6956",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8978",
  "immutable-less": "/immutable-less/static-1.3365",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11724",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.14318",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6805",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2966",
  "ui-universal-auth": "/ui-universal-auth/static-1.7608",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12634",
  "growth-data-modal": "/growth-data-modal/static-1.4034",
  "navigation-components": "/navigation-components/static-1.13867",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8871",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6252",
  "stripe-connect-js": "/stripe-connect-js/static-1.40",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6694",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.616",
  "normalizr": "/normalizr/static-3.9",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ramda": "/ramda/static-1.7",
  "rxjs": "/rxjs/static-5.10",
  "company-details-service-types": "/company-details-service-types/static-1.2731",
  "final-form": "/final-form/static-1.39",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2802",
  "ContentUtils": "/ContentUtils/static-1.63292",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11752",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3941",
  "simple-logging-lib": "/simple-logging-lib/static-1.1845",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3532",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3589",
  "FileManagerCore": "/FileManagerCore/static-1.34141",
  "FileManagerLib": "/FileManagerLib/static-1.34282",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3634",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "timezone-utils": "/timezone-utils/static-2.4054",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.9053",
  "react-dnd-compat": "/react-dnd-compat/static-1.3465",
  "apps-service-types": "/apps-service-types/static-1.2899",
  "oauth-service-types": "/oauth-service-types/static-1.3110",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5926",
  "nav-meta": "/nav-meta/static-1.25504",
  "react-window": "/react-window/static-1.13",
  "cms-field-types": "/cms-field-types/static-1.3596",
  "content-icons-ui": "/content-icons-ui/static-1.1892",
  "underscore": "/underscore/static-1.8",
  "audio-components": "/audio-components/static-1.4466",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.18641",
  "FileManagerImages": "/FileManagerImages/static-1.31792",
  "urlinator": "/urlinator/static-1.3357",
  "video-components": "/video-components/static-1.7915",
  "video-data-lib": "/video-data-lib/static-1.29563",
  "video-embed": "/video-embed/static-1.30404",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "content-assistance-lib": "/content-assistance-lib/static-1.6313",
  "media-bridge-lib": "/media-bridge-lib/static-1.16720",
  "immerable": "/immerable/static-1.2957",
  "social-insights-client-types": "/social-insights-client-types/static-1.17800",
  "outpost": "/outpost/static-1.3167",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22956"
}
};
